import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import ResultsList from '../components/ResultsList';
import { getProcessedData } from '../services/mailchimp';

const SchoolPage = () => {
  console.log('SchoolPage mounted');
  const { provincie, gemeente, school } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [stats, setStats] = useState(null);
  const [processedData, setProcessedData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const processedData = await getProcessedData();
      setProcessedData(processedData);
      
      const provincieKey = provincie.toLowerCase();
      const gemeenteKey = gemeente.toLowerCase();
      const schoolKey = school.toLowerCase();
      
      if (!processedData[provincieKey]?.gemeentes[gemeenteKey]?.schools[schoolKey]) {
        navigate('/');
        return;
      }

      const schoolData = processedData[provincieKey].gemeentes[gemeenteKey].schools[schoolKey];
      
      // Transform schooljaren into the format expected by ResultsList
      const schooljarenData = schoolData.schooljaren.reduce((acc, jaar) => {
        if (!acc[jaar]) {
          acc[jaar] = {
            displayName: jaar,
            count: 1
          };
        } else {
          acc[jaar].count += 1;
        }
        return acc;
      }, {});

      setStats({
        children: schoolData.count,
        schools: 1
      });
      setData(schooljarenData);
    };

    fetchData();
  }, [provincie, gemeente, school, navigate]);

  if (!data || !processedData) return <div className="loading">Loading...</div>;

  const provincieDisplay = processedData[provincie.toLowerCase()]?.displayName || provincie;
  const gemeenteDisplay = processedData[provincie.toLowerCase()]?.gemeentes[gemeente.toLowerCase()]?.displayName || gemeente;
  const schoolDisplay = processedData[provincie.toLowerCase()]?.gemeentes[gemeente.toLowerCase()]?.schools[school.toLowerCase()]?.displayName || school;

  return (
    <Layout 
      region={`${provincieDisplay} > ${gemeenteDisplay} > ${schoolDisplay}`}
      stats={stats}
      processedData={processedData}
    >
      <div className="prompt">
        <p>Dit zijn de resultaten voor {schoolDisplay}</p>
      </div>
      <div className="break"></div>
      <ResultsList 
        items={data}
        nameHeader="Schooljaar"
        baseUrl={null}
      />
    </Layout>
  );
};

export default SchoolPage;